import { useAuth } from '../context';

export const usePermissions = () => {
  const { user, canCreateContent } = useAuth();

  // All authenticated users are moderators and can perform all actions
  const canViewUsers = () => !!user;
  const canDeleteContent = () => !!user;
  const canEditContent = () => {
    if (!user) return false;
    return true; // All users can edit all content
  };
  const canPublishContent = () => canCreateContent;
  const canViewAdminPanel = () => !!user;
  const canModerateContent = () => !!user;

  return {
    canViewUsers,
    canDeleteContent,
    canEditContent,
    canPublishContent,
    canViewAdminPanel,
    canModerateContent,
    canCreateContent,
  };
};
